import LayerGroupSettings from "./LayerGroupSettings";

import { WmsLayer } from "../layers/WmsLayer";

import React from "react";
import { FeatureLayerGroup } from "./Components/FeatureLayerGroup/FeatureLayerGroup";

class DefaultLayerGroup extends LayerGroupSettings {
  constructor(map = null, layer_group_data) {
    // console.log("DefaultLayerGroup constructor", layer_group_data);
    super(map, layer_group_data);

    const {
      uuid,
      name,
      is_visible_by_default: visible,
      order,
      layer_list: layer_list_data,
    } = layer_group_data;

    Object.assign(this, {
      name,
      visible,
      order,
      layer_list_data,
    });

    this.id = this.id.replace(uuid, `default-${uuid}`);
    this.layers = this.createLayers();
  }

  createLayers = () =>
    this.layer_list_data.map(
      (layer_data) => new WmsLayer(layer_data, this.id, this.map)
    );

  callback_change_filter = () => {};

  getFeatureComponent(layerFeatures) {
    return <FeatureLayerGroup layerFeatures={layerFeatures} key={this.id} />;
  }

  async onLeftClick({ event, map, modeOptions }) {
    const featureComponents = [];

    for (const layer of this.layers) {
      if (!layer.visible || !this.visible) continue;

      let layerFeature = await layer.getFeatureInfoOnClick(event, map);
      if (layerFeature?.length > 0) {
        layerFeature[0] = {
          ...layerFeature[0],
          layer_name: layer.name,
          layer_type: layer.layer_data.layer_type,
        };
        featureComponents.push(layer.getFeatureComponent(layerFeature));
      }
    }

    if (featureComponents.length === 0) {
      return false;
    }
    return this.getFeatureComponent(featureComponents);
  }

  async onRightClick({
    event,
    map,
    modeOptions,
    setModeOptions,
    setEditedGeometry,
  }) {
    // console.log("DefaultLayerGroup onRightClick", setModeOptions);
    const actions = [];

    for (const layer of this.layers) {
      let layerActions = await layer.getActionsOnRightClick({
        event,
        map,
        setEditedGeometry,
        modeOptions,
        setModeOptions,
      });
      if (layerActions?.length > 0 && layer.visible && this.visible) {
        layerActions[0] = {
          ...layerActions[0],
          layer_name: layer.name,
          layer_type: layer.layer_data.layer_type,
        };
        actions.push(...layerActions);
      }
    }

    if (actions.length === 0) {
      return false;
    }
    return actions;
  }
}
export default DefaultLayerGroup;
